module.exports = __webpack_public_path__ + "img/grade-4.546591bb.png";